import { TvGuideAPI, TvGuideApi } from './tvGuide';
import { ContentAPI, ContentApi } from './content';
import { NavigationAPI, NavigationApi } from './navigation';
import { FeedAPI, FeedApi } from './feed';
import { ScoreAPI, ScoreApi } from './score';
import { FootballAPI, FootballApi } from './football';
import { RugbyAPI, RugbyApi } from './rugby';
import { CricketAPI, CricketApi } from './cricket';
import { MotorsportAPI, MotorsportApi } from './motorsport';
import { TennisApi, TennisAPI } from './tennis';
import { GolfApi, GolfAPI } from './golf';
import { RawApi } from '.';

export interface MergedApi extends
  TvGuideAPI,
  NavigationAPI,
  ContentAPI,
  FeedAPI,
  ScoreAPI,
  FootballAPI,
  RugbyAPI,
  CricketAPI,
  TennisAPI,
  GolfAPI,
  MotorsportAPI {}
export class MergedApi {}

const applyMixins = (derivedCtor: any, baseCtors: any[]) => {
  baseCtors.forEach((baseCtor) => {
    Object.getOwnPropertyNames(baseCtor.prototype).forEach((name) => {
      Object.defineProperty(derivedCtor.prototype, name, Object.getOwnPropertyDescriptor(baseCtor.prototype, name)!);
    });
  });
};

applyMixins(MergedApi, [
  TvGuideApi,
  NavigationApi,
  ContentApi,
  FeedApi,
  ScoreApi,
  FootballApi,
  RugbyApi,
  CricketApi,
  TennisApi,
  MotorsportApi,
  TennisApi,
  GolfApi,
  RawApi,
]);
const Api = new MergedApi();

export default Api;
